/*----------------------------------------------------------------------------------------
   Función para trabajar el API de Google maps
----------------------------------------------------------------------------------------*/
function _initCustomMap() {
  let mapCustom;
  const bounds = new google.maps.LatLngBounds();

  const mapTarget = document.getElementById("map");
  const $data = JSON.parse(mapTarget.dataset.markers.toString());
  const icons = JSON.parse(mapTarget.dataset.settings.toString());

  const streets = [];
  const locations = [];
  const store = [];
  const storeUrl = [];
  const urlLocations = [];
  const id = [];

  let count = 0;
  $data.forEach((data) => {
    count++;
    streets[count] = data.street;
    locations[count] = { lat: parseFloat(data.lat), lng: parseFloat(data.lng) };
    store[count] = data.store;
    storeUrl[count] = data.url_store;
    urlLocations[count] = data.url_location;
    id[count] = count;
  });

  mapCustom = new google.maps.Map(mapTarget, {
    zoom: 4,
    minZoom: 4,
    maxZoom: 15,
    gestureHandling: "cooperative",
    disableDefaultUI: true,
    clickableIcons: true,
  });

  const infoWindow = new google.maps.InfoWindow({
    content: "",
    disableAutoPan: false,
  });

  const markers = streets.map((street, i) => {
    const icon = {
      url: icons["icon"],
      scaledSize: new google.maps.Size(35, 35),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(35, 35),
    };

    const icon_hover = {
      url: icons["icon_hover"],
      scaledSize: new google.maps.Size(35, 35),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(35, 35),
    };

    const datalistOption = document.querySelectorAll("#street_list option");
    let url;

    let location = locations[i];
    let urlLocation = urlLocations[i];

    mapCustom.setCenter(location);
    var marker = new google.maps.Marker({
      map: mapCustom,
      position: location,
      street,
      icon: icon,
      optimized: false,
    });

    bounds.extend(location);

    if ( urlLocation !== "" ){
      url = urlLocation;
    } else {
      url = "http://maps.google.com/?q=" + encodeURIComponent(street);
    }

    const content =
      '<div class="container_content__icon-map">' +
      '<div class="container__icon-map">' +
      '<h2 class="title__icon-map">' +
      store[i] +
      "</h2>" +
      '<a href="https://' +
      storeUrl[i] +
      '" rel="nofollow noopener noreferrer" class="button__icon-map" target="_blank">' +
      storeUrl[i] +
      "</a>" +
      "<hr>" +
      '<p class="street__icon-map">' +
      via +
      "</p>" +
      '<a href="' +
      url +
      '" rel="nofollow noopener noreferrer" class="button__icon-map" target="_blank">Visualizza su Google Maps</a>' +
      "</div>" +
      "</div>";

    google.maps.event.addDomListener(datalistOption[i - 1], "click", () => {
      infoWindow.setContent(content);
      infoWindow.open(mapCustom, marker);
      mapCustom.panTo(marker.getPosition());
    });

    marker.addListener("click", () => {
      infoWindow.setContent(content);
      infoWindow.open(mapCustom, marker);
    });

    marker.addListener("mouseover", () => {
      marker.setIcon(icon_hover);
      marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
    });

    marker.addListener("mouseout", () => {
      marker.setIcon(icon);
      marker.setZIndex(1);
    });

    let element_id = "[id='" + id[i] + "']";
    let $element = document.querySelectorAll(element_id);

    if ($element.length != 0) {
      let $id = $element[0];
      let $element_link = $id.querySelectorAll("a");

      $id.addEventListener("click", () => {
        infoWindow.setContent(content);
		    infoWindow.open(map, marker);
        if (window.innerWidth < 981) {
          window.scrollTo({top: 0, behavior: 'smooth'});
        }
      });

      $element_link.forEach(link => {
        link.addEventListener("click", function(){
          event.stopPropagation();
        }, false );
      });

      $id.addEventListener("mouseover", () => {
        if (window.innerWidth > 981) {
          marker.setIcon(icon_hover);
          marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1);
          infoWindow.setContent(content);
		      infoWindow.open(map, marker);
        }
      });

      $id.addEventListener("mouseout", () => {
        if (window.innerWidth > 981) {
          marker.setIcon(icon);
          marker.setZIndex(1);
          //infoWindow.close();
        }
      });
    }

    marker.setMap(mapCustom);
    return marker;
  });

  mapCustom.fitBounds(bounds);
}

// Clase para configurar el buscador de Google maps
class DataList {
  constructor(inputId) {
    this.inputId = inputId;
  }

  addListeners(datalist) {
    const container = document.getElementsByTagName("body")[0];
    const input = document.getElementById(this.inputId);
    const list_id = input.dataset.list;
    const list_options = "#" + list_id + " option";
    const options = document.querySelectorAll(list_options);
    const list = document.getElementById(list_id);

    container.addEventListener("click", (e) => {
      if (e.target.id === this.inputId) {
        container.classList.add("datalist");
      } else {
        container.classList.remove("datalist");
      }
    });

    input.addEventListener("input", (e) => {
      if (!container.classList.contains("datalist")) {
        container.classList.add("datalist");
      }

      for (let option of options) {
        var option_text = normalize_string(option.innerText.toLowerCase());
        var value_needle = normalize_string(input.value.toLowerCase());
        var array_text = array_text + option_text + "-";

        if (value_needle != "-") {
          if (option_text.includes(value_needle)) {
            option.style.display = "";
          } else {
            option.style.display = "none";
          }
        }
      }

      if (value_needle != " " && array_text.includes(value_needle)) {
        options[0].parentNode.style.display = "";
      } else {
        options[0].parentNode.style.display = "none";
      }
    });

    input.addEventListener("click", (e) => {
      if (!container.classList.contains("datalist")) {
        container.classList.add("datalist");
      }

      for (let option of options) {
        var option_text = normalize_string(option.innerText.toLowerCase());
        var value_needle = normalize_string(input.value.toLowerCase());
        var array_text = array_text + option_text + "-";

        if (value_needle != "-") {
          if (option_text.includes(value_needle)) {
            option.style.display = "";
          } else {
            option.style.display = "none";
          }
        }
      }

      if (value_needle != " " && array_text.includes(value_needle)) {
        options[0].parentNode.style.display = "";
      } else {
        options[0].parentNode.style.display = "none";
      }
    });

    input.addEventListener("focus", (e) => {
      list.scrollTo(0, 0);
    });

    list.addEventListener("click", (e) => {
      if (e.target.nodeName.toLocaleLowerCase() === "option") {
        //input.value = e.target.innerText;
        input.value = "";
        container.classList.remove("datalist");
      }
    });
  }
}

//Función para eliminar tildes y simbolos raros de los string
const normalize_string = (function () {
  var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
    to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
    mapping = {};

  for (var i = 0, j = from.length; i < j; i++)
    mapping[from.charAt(i)] = to.charAt(i);

  return function (str) {
    var ret = [];
    for (var i = 0, j = str.length; i < j; i++) {
      var c = str.charAt(i);
      if (mapping.hasOwnProperty(str.charAt(i))) ret.push(mapping[c]);
      else ret.push(c);
    }
    return ret.join("");
  };
})();

//Añadir API Google maps
const mapActive = document.querySelectorAll("#map");
if (mapActive.length != 0) {
  const data = JSON.parse(mapActive[0].dataset.settings.toString());
  const apiMaps = document.createElement("script");
  apiMaps.setAttribute("id", "google_map_api");
  apiMaps.setAttribute(
    "src",
    "https://maps.googleapis.com/maps/api/js?key=" +
      data["key"] +
      "&callback=_initCustomMap"
  );
  apiMaps.setAttribute("type", "text/javascript");
  const head = document.querySelector("head");
  head.appendChild(apiMaps);

  //Añadir funcionalidad del buscador
  const datalist = new DataList("street");
  datalist.addListeners(datalist);
}

